import { Pipe, PipeTransform } from '@angular/core';
import {IBroker} from "../domain/IBroker";

@Pipe({
  name: 'filterName'
})
export class FilterNamePipe implements PipeTransform {

  transform(items: IBroker[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (searchText === null) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      const fullName = `${it.displayName} ${it.code}`;
      return fullName.toLowerCase().includes(searchText);
    });
  }

}
